import { render, staticRenderFns } from "./select-assignment-level.vue?vue&type=template&id=ec6668d8"
import script from "./select-assignment-level.vue?vue&type=script&lang=js"
export * from "./select-assignment-level.vue?vue&type=script&lang=js"
import style0 from "./select-assignment-level.vue?vue&type=style&index=0&id=ec6668d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports